const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
};

const updateTotalFabricAvailability = (wrapper, variant, product) => {
  const productCategory = wrapper.dataset.category || "";

  if (productCategory.toLowerCase() !== "fabric") return;

  const totalFabricAvailabilityElem = wrapper.querySelector(
    `#total-fabric-availability-${wrapper.dataset.product} .product__inventory-inner`
  );

  if (!totalFabricAvailabilityElem) {
    return;
  }

  const selectedColor = variant.option1;
  let totalFabricQuantity = 0;

  product.variants.forEach((variant) => {
    if (
      variant.option1 === selectedColor &&
      !variant.title.includes("Campione") &&
      !variant.title.includes("Sample") &&
      !variant.title.includes("Échantillon")
    ) {
      const rollLength = parseFloat(variant.option2.replace(",", "."));
      totalFabricQuantity += rollLength;
    }
  });

  if (totalFabricQuantity > 0) {
    const totalFabricLocalized = totalFabricQuantity
      .toFixed(2)
      .replace(".", ",");
    totalFabricAvailabilityElem.innerHTML = `${totalFabricLocalized} m`;
  } else {
    totalFabricAvailabilityElem.innerHTML = "N/A";
  }
};

const updateTotalLeatherAvailability = (wrapper, variant, product) => {
  const productCategory = wrapper.dataset.category || "";

  if (productCategory.toLowerCase() !== "leather & vinyl") return;

  const totalLeatherAvailabilityElem = wrapper.querySelector(
    `#total-leather-availability-${wrapper.dataset.product} .product__inventory-inner`
  );

  if (!totalLeatherAvailabilityElem) {
    return;
  }

  const averageHideSize = wrapper
    .querySelector(`#total-leather-availability-${wrapper.dataset.product}`)
    .getAttribute("data-average-hide-size");

  if (!averageHideSize || isNaN(averageHideSize)) {
    totalLeatherAvailabilityElem.innerHTML = "N/A";
    return;
  }

  const selectedColor = variant.option1;
  let totalLeatherQuantity = 0;

  product.variants.forEach((variant) => {
    if (variant.option1 === selectedColor) {
      const numberOfHides = wrapper
        .querySelector(`[data-inventory-${variant.id}]`)
        ?.getAttribute(`data-inventory-${variant.id}`);

      if (numberOfHides) {
        const variantLeatherQuantity =
          numberOfHides * parseFloat(averageHideSize);
        totalLeatherQuantity += variantLeatherQuantity;
      }
    }
  });

  if (totalLeatherQuantity > 0) {
    const totalLeatherLocalized = totalLeatherQuantity
      .toFixed(2)
      .replace(".", ",");
    totalLeatherAvailabilityElem.innerHTML = `${totalLeatherLocalized} m²`;
  } else {
    totalLeatherAvailabilityElem.innerHTML = "N/A";
  }
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelector(".js-color-swatches-link")
            .setAttribute("href", event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            if (
              wrapper.querySelector(
                '.card__add-to-cart button[name="add"] > span'
              )
            ) {
              wrapper
                .querySelector('.card__add-to-cart button[name="add"] > span')
                .classList.remove("hidden");
              wrapper
                .querySelector(
                  '.card__add-to-cart button[name="add"] .sold-out-message'
                )
                .classList.add("hidden");
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }

          const currentColor = event.currentTarget.value;

          jQuery.getJSON(
            window.Shopify.routes.root + `products/${handleProduct}.js`,
            function (product) {
              const variant = product.variants.filter(
                (item) =>
                  item.featured_media != null &&
                  item.options.includes(currentColor)
              )[0];

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src)
                      .pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                      .pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      flag = true;
                    }
                  }
                  if (flag == false) {
                    primaryImage.animate(
                      { opacity: [1, 0] },
                      { duration: 200, easing: "ease-in", fill: "forwards" }
                    ).finished;
                    setTimeout(function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }

                // Call the appropriate availability function based on the category
                const productCategory = wrapper.dataset.category || "";

                if (productCategory.toLowerCase() === "fabric") {
                  updateTotalFabricAvailability(wrapper, variant, product);
                }

                if (productCategory.toLowerCase() === "leather & vinyl") {
                  updateTotalLeatherAvailability(wrapper, variant, product);
                }
              }
            }
          );
        }
      });
    });
  });
};

// Initialize swatch functionality and listen for section load
function colorSwatches() {
  checkSwatches();
  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

// Start everything
(function () {
  colorSwatches();
})();
